import React from 'react';
import cn from 'classnames';
import styles from './Spinner.module.scss';

function Spinner({ size, absolute, fixed }) {
  const hasSize = ['small', 'large'].includes(size);

  return (
    <div
      className={cn(
        styles.preloader,
        hasSize ? styles[`size-${size}`] : '',
        absolute ? styles.absolute : '',
        fixed ? styles.fixed : '',
      )}
    />
  );
}

export default Spinner;
